import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import publicHome from '../views/_Public.vue'
// import publicWizard from '../views/_PublicWizard.vue'
import privateHome from '../views/_Private.vue'
import notifications from '@/router/modules/notifications'
import companies from '@/router/modules/companies'
import certificates from '@/router/modules/certificates'
import configurations from '@/router/modules/configurations'
import trash from '@/router/modules/trash'
import notificationsNotices from '@/router/modules/notificationsNotices'

import dashboard from '@/router/modules/dashboard'

import { RUTAS_CAMBIOS_FORMULARIOS } from '@/config/rutas-cambios-formularios'
import { i18n } from '@/i18n'
import { installRouteFocus } from '@/utils/routeA11yFocus'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: publicHome,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: { type: 'public', title: i18n.t('app.title_login') },
        component: () => import('@/views/Login.vue')
      },
      {
        path: '',
        name: 'signin',
        redirect: { name: 'login' }
      },
      {
        path: 'reset-password/:token',
        name: 'reset-password',
        meta: { type: 'public', title: i18n.t('app.title_resetpassowrd') },
        component: () => import('@/views/ResetPassword.vue')
      },
      {
        path: 'redirect',
        name: 'redirect',
        meta: { type: 'public', title: i18n.t('app.title_redirect') },
        component: () => import('@/views/RedirectionPage.vue')
      },
      {
        path: 'redirect/saml2',
        name: 'redirect/saml2',
        meta: { type: 'public', title: i18n.t('app.title_redirect') },
        component: () => import('@/views/RedirectSaml2.vue')
      },
      {
        path: 'redirect/error',
        name: 'redirect/error',
        meta: { type: 'public', title: i18n.t('app.title_error') },
        component: () => import('@/views/RedirectionError.vue')
      },
    ]
  },
  
  {
    path: '/'+process.env.VUE_APP_ROUTE_BASE,
    component: privateHome,
    children: [
      ...notifications,
      ...companies,
      ...certificates,
      ...configurations,
      ...trash,
      ...dashboard,
      ...notificationsNotices
    ]
  },
  {
    path: '*',
    name: 'notfound',
    component: () => import('@/views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

router.beforeEach(async (to, from, next) => {
  store.commit('app/setActualRoute', to.path)
  store.commit('app/setfromRouteName', from.name)

  let type = 'private'
  if (to.meta && to.meta.type) {
    type = to.meta.type
  }
  store.commit('app/setActualRoutePublic', (type === 'public'))

  if (to.name === 'reset-password' || to.name === 'redirect/saml2') {
    return next()
  }

  const loggedIn = store.getters['auth/loggedIn']
  if (type === 'private') {
    if (loggedIn) {
      // Control formularios con cambios sin guardar 
      if (store.getters['app/formChanges'] && RUTAS_CAMBIOS_FORMULARIOS.includes(from.name)) {
        const route = {
          path: to.path,
          params: to.params,
          query: to.query,
        }
        // Guardamos ruta para el diálogo y lo activamos
        store.commit('app/setLastRouteComplete', route)
        store.commit('app/setShowModalConfirmChanges', true)
        // Cancelamos ruta
        return
      } 

      // Hotfix refresh NEO status
      if ((to.name === null || to.name === undefined) && to.path.includes('/'+process.env.VUE_APP_ROUTE_BASE+'/notifications')) {
        return next({ name: 'notifications' })
      }
      
      return next()
    }
    return next({ name: process.env.VUE_APP_REDIRECT_FAILED_AUTHENTICATION })
  }

  if (type === 'public') {
    if (loggedIn) {
      return next({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN })
    }
  }

  return next()
})

// WCAG 2.1 AA — SC 2.4.3 Focus Order en cambios de ruta (SPA). Lógica en util aparte.
installRouteFocus(router)

router.afterEach((to, from) => {
  document.title = to.meta.title
    ? to.meta.title + ' - EdasNEO'
    : to.path.includes('/zerocoma/notifications/')
      ? 'Notificaciones - EdasNEO'
      : process.env.VUE_APP_TITLE
})
